import React, { useState, useEffect } from "react";
import "./Ticket.scss";
import TicketImg from "../../assets/images/ticket.png";
import { ticketData } from "../../data/data";
import { ReactComponent as Check } from "../../assets/svg/check.svg";
import { useGlobalContext } from "../../contexts/context";
import RegisterModal from "../../components/TicketModal/TicketModal";
import { benefits } from "../../data/data";

const Ticket = () => {
  const { isModalOpen, showModal, isModalClose } = useGlobalContext();
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    const selectedTicketRef = document.getElementById(`ticket-${selectedTab}`);
    if (selectedTicketRef) {
      if (window.innerWidth <= 768) {
        const yOffset = selectedTicketRef.offsetTop - 20;
        window.scrollTo({ top: yOffset, behavior: "smooth" });
      }
    }
  }, [selectedTab]);
  function handleTabClick(index) {
    setSelectedTab(index);
  }

  return (
    <>
      <section className="section ticket" id="next-section">
        <article className="ticket__container container">
          <div className="ticket__container-header">
            <div className="header-contents">
              <h3>Get Your Ticket</h3>
              <h1>TOGETHER FOR A BETTER WORLD AT TEDxOAU 2023</h1>
              <p>
                TEDxOAU 2023 is all about exploring how our collective
                intellect, creativity, and passion can propel us forward as
                responsible global citizens, offering insights and solutions to
                the challenges of our time.
                <br /> <br />
                Join us on OAU Campus at TEDxOAU2023, the 3rd edition, to
                celebrate innovation, design thinking, industry shakers and the
                ingenuity of people.
              </p>
              <br />
              <p>
                Questions? Send us a note to <span>oautedx@gmail.com</span>
              </p>
            </div>
            <figure className="header-image">
              <img src={TicketImg} alt="theme" />
            </figure>
          </div>
          <div className="ticket__container-contents">
            <div className="contents-left">
              {ticketData.map((ticket, index) => {
                const { title, description, price } = ticket;
                return (
                  <div
                    key={index}
                    className={`contents-component ${
                      selectedTab === index ? "current" : ""
                    }`}
                    onClick={() => handleTabClick(index)}
                    id={`ticket-${index}`}
                  >
                    <div className="component-details">
                      <h2>{title}</h2>
                      <p>{description}</p>
                    </div>

                    <div className="component-price">
                      <p>
                        <span>₦</span> {price}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="contents-right">
              <div className="contents-right-text">
                <h3>{`Included with a ${ticketData[selectedTab].title} Ticket`}</h3>
                <p>{`All the benefits of a ${ticketData[selectedTab].title} Ticket, include:`}</p>
                <ul>
                  {benefits[selectedTab].map((benefit, index) => (
                    <li key={index}>
                      <Check />
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="contents-right-button">
                <button type="button" onClick={isModalOpen}>
                  Buy Ticket
                </button>
              </div>
            </div>
          </div>

          <div className="ticket__container-details">
            <h1 className="details-header">Ticket Category Details</h1>
            <div className="details-container">
              <div className="vanguard-details">
                <h2>
                  Regular (NGN2,000){" "}
                  {/* <span className="slash-price">NGN5,000</span> */}
                </h2>
                <p>For a budget-friendly experience</p>
                <p>Included with a Regular Ticket</p>
                <h4>All the benefits of a Regular Ticket include:</h4>
                <ul>
                  <li>All day conference experience</li>
                  <li>Conference meal: Breakfast and snacks for lunch</li>
                  <li>Live video Stream access</li>
                  <li>Conference photo and video archive</li>
                  <li>Access to TEDxOAU Community</li>
                </ul>
              </div>

              <div className="vanguard-details">
                <h2>
                  Vanguard (NGN5,000){" "}
                  {/* <span className="slash-price">NGN5,000</span> */}
                </h2>
                <p>For an enjoyable experience</p>
                <p>Included with a Vanguard Ticket</p>
                <h4>All the benefits of a Vanguard Ticket include:</h4>
                <ul>
                  <li>All day conference experience</li>
                  <li>Conference meal: Breakfast and snacks for lunch</li>
                  <li>Conference pack: Includes conference tag and souvenir</li>
                  <li>Live video Stream access</li>
                  <li>One professional head shot</li>
                  <li>Conference photo and video archive</li>
                  <li>Access to TEDxOAU Community</li>
                </ul>
              </div>

              <div className="vanguard-details">
                <h2>
                  Standard (NGN7,000){" "}
                  {/* <span className="slash-price">NGN7,000</span> */}
                </h2>
                <p>For an over-the-top experience</p>
                <p>Included with a Standard Ticket</p>
                <h4>All the benefits of a Standard Ticket include:</h4>
                <ul>
                  <li>Access to the full TEDxOAU 2023 experience</li>
                  <li>All day conference experience</li>
                  <li>
                    Conference meal: Breakfast and packaged meal for Lunch
                  </li>
                  <li>Conference pack: Includes conference tag and souvenir</li>
                  <li>Early access to conference venue</li>
                  <li>Live videoStream access</li>
                  <li>One professional headshot</li>
                  <li>Conference photo and video archive</li>
                  <li>Access to TEDxOAU Community</li>
                  <li>Opportunity to transfer ticket ownership</li>
                </ul>
              </div>

              <div className="vanguard-details">
                <h2>
                  Premium (NGN10,000){" "}
                  {/* <span className="slash-price">NGN10,000</span> */}
                </h2>
                <p>For a lavish and exclusive conference experience</p>
                <p>Included with a Premium Ticket,</p>
                <h4>All benefits of a Premium Ticket include:</h4>
                <ul>
                  <li>All day conference experience </li>
                  <li>
                    Conference meal: Breakfast and packaged meal for Lunch
                  </li>
                  <li>Conference pack: Includes conference tag and souvenir</li>
                  <li>
                    Exclusive access to a networking party with speakers and
                    organizers
                  </li>
                  <li>Early access to conference venue</li>
                  <li>Live videoStream access</li>
                  <li>One professional head shot</li>
                  <li>Conference photo and video archive</li>
                  <li>Access to the TEDxOAU community</li>
                  <li>Opportunity to transfer ticket ownership</li>
                </ul>
              </div>

              <div className="vanguard-details">
                <h2>
                  Donor (NGN50,000){" "}
                  {/* <span className="slash-price">NGN50,000</span> */}
                </h2>
                <p>An act of generosity that supports TEDxOAU’s mission</p>
                <p>Included with a Donor Ticket,</p>
                <h4>All benefits of a Donor Ticket include:</h4>
                <ul>
                  <li>All day conference experience </li>
                  <li>
                    Conference meal: Breakfast and packaged meal for Lunch
                  </li>
                  <li>Conference pack: Includes conference tag and souvenir</li>
                  <li>
                    Exclusive access to a networking party with speakers and
                    organizers
                  </li>
                  <li>Early access to conference venue</li>
                  <li>Live video stream access</li>
                  <li>One professional head shot</li>
                  <li>Conference photo and video archive</li>
                  <li>Access to the TEDxOAU community</li>
                  <li>Onstage and social media recognition </li>
                  <li>Cross collaboration on social media</li>
                </ul>
              </div>
            </div>
          </div>
        </article>
      </section>

      <RegisterModal onClose={isModalClose} showModal={showModal} />
    </>
  );
};

export default Ticket;
